import React from 'react'

function About (){
  return (
    <div className='a' id='about'>

    <div className='about'>
        <h1>ABOUT US</h1> 
          <p style={{fontSize: "20px"}}>Welcome to Gig-Finder, where you can find jobs in your area. We have a large database<br></br><br></br> of local businesses, so it's easy to find jobs that are right for you.
          Have an idea of what<br></br><br></br> you'd like to do?<br></br><br></br>Search by industry and location to find the perfect job or internship.<br></br><br></br>
          You can also search by keyword, so that when an employer is looking for someone with<br></br><br></br> your skillset,
          they'll see you! If you're looking for something new and exciting, we've got<br></br><br></br> plenty of opportunities for that too—we always have new opportunities posted. If you're<br></br><br></br> 
          still unsure about which company will be right for you, take a minute to explore our career<br></br><br></br> center—you'll be amazed at how much information is available there.
          </p>
    </div>
    </div>
    
    
  )
}

export default About